import type { UseMutationResult } from '@tanstack/react-query';
import { useBffPostMutation } from '../bff';
import type { CustomerForgotPasswordRequest } from './model/CustomerForgotPasswordRequest';

export const useCustomerForgotPassword = (): UseMutationResult<
    unknown,
    unknown,
    CustomerForgotPasswordRequest
> => useBffPostMutation<unknown, CustomerForgotPasswordRequest>('/customers/forgot-password');
